import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { ModuleRenewalControlHistoryProps } from "./companyPurchaseContracts";

export function ModuleRenewalControlHistory({ page, selectedPurchaseId, resumingOperationId, resumeDisabled,
  recoveryResult, onResume, onPage }: ModuleRenewalControlHistoryProps) {
  if (page.purchase_id !== selectedPurchaseId) return null;
  const result = recoveryResult?.purchase_id === selectedPurchaseId ? recoveryResult : null;
  return <Stack spacing={1.5} aria-label="Original renewal requests">
    {!page.items.length ? <Typography>No original renewal requests returned.</Typography> : page.items.map(item => {
      const resolved = result?.control.operation_id === item.operation_id && result.control.action === item.action
        && result.control.admitted_licence_revision === item.admitted_licence_revision && result.control.created_at === item.created_at
        ? result : null;
      return <Stack key={item.operation_id} spacing={0.5}>
        <Typography>{item.action === "stop_renewal" ? "Stop renewal" : "Restore renewal"} requested {new Date(item.created_at).toLocaleString()} — {item.operation_status}</Typography>
        {resolved ? <Typography role="status">{resolved.resolution === "original_result"
          ? resolved.reason === null ? "Original renewal request confirmed" : "Original renewal request failed"
          : resolved.resolution === "observed_current_effect" ? "Stored matching effect; original response unknown."
            : `Original renewal request unresolved: ${resolved.reason?.replaceAll("_", " ")}.`}</Typography> : null}
        <Button size="small" sx={{ alignSelf: "flex-start" }} disabled={resumeDisabled || resumingOperationId !== null}
          onClick={() => { if (!resumeDisabled && resumingOperationId === null) onResume(item); }}>Resume original renewal request</Button>
      </Stack>;
    })}
    {page.offset > 0 || page.total > page.limit ? <Stack direction="row" spacing={1}>
      <Button size="small" aria-label="Previous renewal requests" disabled={resumeDisabled || resumingOperationId !== null || page.offset === 0}
        onClick={() => onPage(Math.max(0, page.offset - page.limit))}>Previous</Button>
      <Button size="small" aria-label="Next renewal requests" disabled={resumeDisabled || resumingOperationId !== null || page.offset + page.items.length >= page.total}
        onClick={() => onPage(page.offset + page.limit)}>Next</Button>
    </Stack> : null}
  </Stack>;
}
